import { render, staticRenderFns } from "./ModalPedido.vue?vue&type=template&id=01bfefe1&scoped=true"
import script from "./ModalPedido.vue?vue&type=script&lang=js"
export * from "./ModalPedido.vue?vue&type=script&lang=js"
import style0 from "./ModalPedido.vue?vue&type=style&index=0&id=01bfefe1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bfefe1",
  null
  
)

export default component.exports